/**
 * Deterministic internal-link anchor rotation.
 *
 * Same source+target pair always produces the same anchor text, but
 * different source pages link with different natural phrasing.
 */

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

/** Pick one anchor variant deterministically for a source → target pair. */
export function pickAnchor(sourcePath: string, target: string, variants: string[]): string {
  if (!variants.length) return target;
  return variants[hash(`${sourcePath}→${target}`) % variants.length];
}

/** Natural anchor variants for a gold-rate target. */
export function goldAnchorVariants(place: string): string[] {
  return [
    `${place} gold rate today`,
    `today gold price in ${place}`,
    `live ${place} gold rates`,
    `${place} 22k & 24k gold price`,
    `gold rate ${place} per tola & gram`,
  ];
}

/** Natural anchor variants for a silver-rate target. */
export function silverAnchorVariants(place: string): string[] {
  return [
    `${place} silver rate today`,
    `today silver price in ${place}`,
    `live ${place} silver rates`,
    `${place} chandi ka rate`,
    `silver rate ${place} per tola & gram`,
  ];
}
